export default function Disk(props) {
  return (
    <span class="disk" {...props}>
      <span class="diskloader"></span>
    </span>
  );
}
